// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dashboard[data-v-22458e54] {\n\tmin-height: 700px;\n}\n", ""]);
// Exports
module.exports = exports;
